module.exports = __webpack_public_path__ + "static/media/my_settings.beeda2dd.svg";